export function selectInspectionReport() {
  return (state) => state.seeInspection.current?.inspectionReport;
}